import React from "react";
import { Box, Typography, Card } from "@mui/material";
import { styled } from "@mui/system";
import moment from "moment-timezone";
import useStyles from "./style";

const MessageArea = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  padding: "16px",
  overflowY: "auto",
});


const MessageBubble = styled(Card)(({ sent }) => ({
  maxWidth: "70%",
  padding: "10px",
  borderRadius: "12px",
  backgroundColor: sent ? "#1976d2" : "#dfdfdf",
  color: sent ? "white" : "black",
  alignSelf: sent ? "flex-end" : "flex-start",
}));

const ChatApp = ({ chatdetails }) => {
    const classes = useStyles();
  // Flatten and sort messages by timestamp
  const sortedMessages = chatdetails
    .flatMap(chat => 
      chat.messagedetails.map(msg => ({
        ...msg,
        senderType: chat.sendBy,
        senderName: chat.senderName // Add sender type
      }))
    )
    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp)); // Sort by time

  return (
    <Box className={classes.chatbox}>
      <Typography variant="h6">Chats</Typography>
      <MessageArea>
        {sortedMessages.map((msg, index) => (
          <MessageBubble key={index} sent={msg.senderType === "DRIVER"}>
            <Typography>{msg.message}</Typography>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              {moment(msg.timestamp).format("hh:mm A")+"  ("+msg.senderName+")"}
            </Typography>
          </MessageBubble>
        ))}
      </MessageArea>
    </Box>
  );
};

export default ChatApp;
